module.exports = __webpack_public_path__ + "img/stamp@2x.4984ab7b.png";